var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "app--main"
  }, [_c('div', {
    staticClass: "visual"
  }, [_c('div', {
    staticClass: "background"
  }, [_c('div', {
    staticClass: "visual__con"
  }, [_c('div', {
    staticClass: "text-ani-wrap"
  }, [_c('div', {
    staticClass: "text-ani mb-14 mb-lg-30"
  }, [_c('h2', {
    staticClass: "main-tit visual__tit"
  }, [_vm._v(" Global Productivity & Eco-Friendly ")])]), _c('div', {
    staticClass: "text-ani"
  }, [_c('p', {
    staticClass: "visual__txt"
  }, [_vm._v(" Every year, Meitextile takes advantage of the strength of R&D to keep pace with market trends with ")])]), _c('div', {
    staticClass: "text-ani"
  }, [_c('p', {
    staticClass: "visual__txt"
  }, [_vm._v(" global productivity and fast response. We are also working hard to develop eco-friendly and ")])]), _c('div', {
    staticClass: "text-ani"
  }, [_c('p', {
    staticClass: "visual__txt"
  }, [_vm._v(" reusable fabrics for sustainable development. ")])])])]), _c('div', {
    staticClass: "video-bg"
  }, [_c('video', {
    staticClass: "video-bg__video",
    attrs: {
      "playsinline": "",
      "muted": "",
      "loop": "",
      "autoplay": "",
      "poster": "/images/main/visual-poster.jpg"
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "src": "/images/main/visual.mp4",
      "type": "video/mp4"
    }
  }), _c('strong', [_vm._v("웹 브라우저가 video를 지원하지 않습니다.")])])])])]), _c('div', {
    staticClass: "main-contents"
  }, [_c('section', {
    staticClass: "main-section main-section--first"
  }, [_c('v-container', [_c('div', {
    staticClass: "prd-slide"
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-control"
  }, [_c('div', {
    staticClass: "control-top"
  }, [_c('h2', {
    staticClass: "main-tit mb-lg-46 mb-xl-92",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Product")]), _c('div', {
    staticClass: "pagination"
  })]), _c('div', {
    staticClass: "control-bottom"
  }, [_c('v-btn', {
    staticClass: "prev-btn",
    attrs: {
      "icon": "",
      "tile": "",
      "large": "",
      "color": "white"
    }
  }, [_c('i', {
    staticClass: "icon icon-left-arrow"
  })]), _c('v-btn', {
    staticClass: "next-btn",
    attrs: {
      "icon": "",
      "tile": "",
      "large": "",
      "color": "white"
    }
  }, [_c('i', {
    staticClass: "icon icon-right-arrow"
  })])], 1)]), _c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('main-product', {
    attrs: {
      "link": "/product/organic",
      "mainImage": "/images/main/prd-1.jpg",
      "slideImage1": "/images/main/prd-1-1.jpg",
      "slideImage2": "/images/main/prd-1-2.jpg",
      "slideImage3": "/images/main/prd-1-3.jpg",
      "slideImage4": "/images/main/prd-1-4.jpg",
      "slideImage5": "/images/main/prd-1-5.jpg",
      "tit": "Organic Line"
    }
  }, [_vm._v(" Organic cotton, Better cotton, Bamboo, Recycled poly, Sorona , Eco "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" Vero, etc. All we must care about the Environment. Accordingly, we "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" are working with factories with certification. Join Meitex to protect "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" the environment! ")])], 1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('main-product', {
    attrs: {
      "link": "/product/sports",
      "mainImage": "/images/main/prd-2.jpg",
      "slideImage1": "/images/main/prd-2-1.jpg",
      "slideImage2": "/images/main/prd-2-2.jpg",
      "slideImage3": "/images/main/prd-2-3.jpg",
      "tit": "High Function Sports Line"
    }
  }, [_vm._v(" Moisture-repellent/proof, Cooling/Heating function helps "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" consumer lives a healthy life. These functions starts with "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" high-quality yarn and construction of fabric. Discover a variety of "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" silhouettes and fabrications that enrich your life. ")])], 1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('main-product', {
    attrs: {
      "link": "/product/active",
      "mainImage": "/images/main/prd-3.jpg",
      "slideImage1": "/images/main/prd-3-1.jpg",
      "slideImage2": "/images/main/prd-3-2.jpg",
      "slideImage3": "/images/main/prd-3-3.jpg",
      "slideImage4": "/images/main/prd-3-4.jpg",
      "slideImage5": "/images/main/prd-3-5.jpg",
      "tit": "Active & Legging line"
    }
  }, [_vm._v(" Single/Double knit with printing and foil design, Special pattern with "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" Embossing, Very stretchy and recoverable quality. We have a lot of "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" experience and buyers for these sports & Legging items. Offer your "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" customers affordable and high-quality clothing. ")])], 1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('main-product', {
    attrs: {
      "link": "/product/cotton",
      "mainImage": "/images/main/prd-4.jpg",
      "slideImage1": "/images/main/prd-4-1.jpg",
      "slideImage2": "/images/main/prd-4-2.jpg",
      "slideImage3": "/images/main/prd-4-3.jpg",
      "slideImage4": "/images/main/prd-4-4.jpg",
      "slideImage5": "/images/main/prd-4-5.jpg",
      "tit": "Cotton & Basic Line"
    }
  }, [_vm._v(" Single/Double Knit, Rib, Terry, Tricot with BCI, US, Organic cotton and "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" blended fiber. From premium cotton fabrics to affordable options. "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" We produce any basic knit item with reasonable price. ")])], 1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('main-product', {
    attrs: {
      "link": "/product/fleece",
      "mainImage": "/images/main/prd-5.jpg",
      "slideImage1": "/images/main/prd-5-1.jpg",
      "slideImage2": "/images/main/prd-5-2.jpg",
      "slideImage3": "/images/main/prd-5-3.jpg",
      "slideImage4": "/images/main/prd-5-4.jpg",
      "slideImage5": "/images/main/prd-5-5.jpg",
      "tit": "Fleece & Sherpa Line"
    }
  }, [_vm._v(" Sherpa with short/long pile, Polar fleece, Mink Fleece, Terry Fleece, "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" Velour, Brushed Knit, etc. We have a lot of experience with synthetic "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" blend sherpa and fleece fabrics. Also have special strengths of "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" price and quality. ")])], 1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('main-product', {
    attrs: {
      "link": "/product/novelty",
      "mainImage": "/images/main/prd-6.jpg",
      "slideImage1": "/images/main/prd-6-1.jpg",
      "slideImage2": "/images/main/prd-6-2.jpg",
      "slideImage3": "/images/main/prd-6-3.jpg",
      "slideImage4": "/images/main/prd-6-4.jpg",
      "slideImage5": "/images/main/prd-6-5.jpg",
      "tit": "Novelty Line"
    }
  }, [_vm._v(" Special finished velvet with burn out & novelty printing. Jacquard & "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" Emboss fabric with various patterns. Delicate flocking mesh with "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" luxurious printing. Our R&D handles these items very skillfully. You "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" can meet special items that you can't find anywhere else. ")])], 1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('main-product', {
    attrs: {
      "link": "/product/Comfortable",
      "mainImage": "/images/main/prd-7.jpg",
      "slideImage1": "/images/main/prd-7-1.jpg",
      "slideImage2": "/images/main/prd-7-2.jpg",
      "slideImage3": "/images/main/prd-7-3.jpg",
      "slideImage4": "/images/main/prd-7-4.jpg",
      "slideImage5": "/images/main/prd-7-5.jpg",
      "tit": "Comfortable & Cozy Line"
    }
  }, [_vm._v(" Single, Towel Terry, Fleece, Texture etc, Variety structure with brush effect. "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" From home to outside, Our soft knit line gives you comfort & cozy feeling you need. can meet special items that you can't find anywhere else. ")])], 1)])])])])], 1), _c('section', {
    staticClass: "main-section main-section--last"
  }, [_c('v-container', [_c('h2', {
    staticClass: "main-tit text-center",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Partner Brand")]), _c('v-row', _vm._l(_vm.banners, function (banner, idx) {
    return _c('v-col', {
      key: idx,
      attrs: {
        "cols": "6",
        "md": "3"
      }
    }, [_c('div', {
      staticClass: "partner-thum-wrap"
    }, [_c('v-img', {
      staticClass: "partner-thum",
      attrs: {
        "src": banner.slides[0].image
      }
    })], 1)]);
  }), 1), _c('div', {
    staticClass: "mt-10 mt-lg-24",
    attrs: {
      "id": "moreView"
    }
  }, [_c('v-row', _vm._l(_vm.banners2, function (banner, idx) {
    return _c('v-col', {
      key: idx,
      attrs: {
        "cols": "6",
        "md": "3"
      }
    }, [_c('div', {
      staticClass: "partner-thum-wrap"
    }, [_c('v-img', {
      staticClass: "partner-thum",
      attrs: {
        "src": banner.slides[0].image
      }
    })], 1)]);
  }), 1)], 1), _c('div', {
    staticClass: "d-flex justify-center mt-40 mt-lg-80"
  }, [_c('div', {
    attrs: {
      "id": "moreBtn"
    }
  }, [_c('v-btn', {
    staticClass: "min-w-160px min-w-lg-200px",
    attrs: {
      "outlined": "",
      "color": "primary"
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("View All "), _c('span', {
    staticClass: "ml-6 ml-lg-10 plus more-view-btn"
  })])], 1)])], 1)], 1)]), _c('popup-layer')], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }